<template>
  <div id="app">
    <router-view/>
    <CookieBanner />
  </div>
</template>

<script>
import CookieBanner from './components/CookieBanner.vue'

export default {
  name: 'App',
  components: {
    CookieBanner
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  background-color: #f5f5f5;
}

#app {
  min-height: 100vh;
}
</style>

